import React, { useState } from 'react'
import { Mutation } from 'react-apollo'
import { Link } from 'react-router-dom'
import moment from 'moment'
import {
  message, Menu, Dropdown, Icon, Select as AntdSelect, Button as AntdButton, Modal, DatePicker, Radio,
} from 'antd'
import _ from 'lodash'
import {
  SmallText, Div, Button, Loading,
} from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/trailer-page/constants'
import { UPDATE_TRAILER } from '../../constants/graphql/mutation'
import { Text } from './styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <Text font='sarabun' {...props}>{props.children}</Text>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const StatusCell = ({ disabled, props, refetch }) => {
  const [value, setValue] = useState(statusText[props.value])
  const arr = [
    { value: status.AVAILABLE, text: statusText.AVAILABLE },
    { value: status.REPAIRING, text: statusText.REPAIRING },
    { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
    { value: status.WATCHING, text: statusText.WATCHING },
  ]
  return (
    <Mutation
        mutation={UPDATE_TRAILER}
      >
      {(doUpdateTruck, { loading }) => {
        if (loading) return <Loading/>
        return (
        <Div>
          <AntdSelect
            value={value}
            disabled={disabled}
            dropdown
            maxHeight="none"
            style={{
              backgroundColor: '#00000000',
              color: value === statusText.AVAILABLE
                ? color.success
                : value === statusText.REPAIRING
                  ? color.warning
                  : color.error,
              width: '120px',
            }}
            onChange={(e) => {
              setValue(statusText[e])
              doUpdateTruck({
                variables: {
                  id: props.original.id,
                  status: e,
                },
              }).then((resp) => {
                const response = resp.data.UpdateTruck
                if (response.success) {
                  message.success(response.message)
                  refetch()
                } else message.error(response.message)
              })
            }}
          >
          {
            arr.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
          }
          </AntdSelect>
        </Div>
        )
      }}
    </Mutation>
  )
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/trailer/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='view-log' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/trailer/view-log/${id}`}>
          ดูประวัติการใช้งาน
        </Link>
      </Menu.Item>
      <Menu.Item key='tire-list' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/trailer/tire-list/${id}`}>
          ดูข้อมูลล้อ
        </Link>
      </Menu.Item>
      <Menu.Item key='tire-history-list' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/trailer/tire-history/${id}`}>
          ดูประวัติการใช้ยาง
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TRUCK)}>
        <Link target="_blank" to={`/trailer/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <AntdButton>
      ดูรายละเอียด <Icon type="down" />
    </AntdButton>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, pdfInfo,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [month, setMonth] = useState()
  const [date, setDate] = useState([])
  const [text, setText] = useState([])
  const [radio, setRadio] = useState()

  const download = (id, selectedDate) => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/generateHtmlPadoongrichDriverCompensetionPdf/${id}?start=${moment(selectedDate[0]).format('YYYY-MM-DD')}&end=${moment(selectedDate[1]).format('YYYY-MM-DD')}&t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }

  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <Button
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TRUCK)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/trailer/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateTrailer : data.UpdateTrailer

              if (resp.success) {
                message.success(resp.message)

                if (isAddMode) history.push('/trailer')
              } else message.error(resp.message)
            })
          }
        }}
      />
    </Div>
  )
}
